<template>
  <div class="token">
    <div class="mainHead">
      <div class="head">
        <div class="headLeft" @click="toHome()">
          <!-- <img src="./../assets/headlogo.png" alt="" /> -->
          <div>MTNFT区块链浏览器</div>
        </div>
        <div class="headRight">
          <el-dropdown>
            <div
              style="
                color: black;
                margin-right: 10px;
                height: 35px;
                line-height: 35px;
              "
            >
              {{ type }}<i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in list"
                :key="index"
                @click.native="dropdowns(item)"
                >{{ item }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-input
            :placeholder="placeholder"
            v-model="inputValue"
            class="elInput"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search()"
              style="background-color: #dbdeed"
            ></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="a1">
      <h1>存证信息</h1>
      <div class="details">
        <!--        <el-descriptions title="" :column="1" border style="width: 1200px;margin: 0 auto;margin-top: 50px;" >-->
        <!--            <el-descriptions-item label="交易哈希">-->
        <!--                {{transactionId}}-->
        <!--            </el-descriptions-item>-->
        <!--            <el-descriptions-item label="状态">-->
        <!--                <span v-if="status==0">待上链</span>-->
        <!--                <span v-if="status==1">上链成功</span>-->
        <!--                <span v-if="status==2">上链失败</span>-->
        <!--            </el-descriptions-item>-->
        <!--            <el-descriptions-item label="Token Id">{{tokenId}}</el-descriptions-item>-->
        <!--            <el-descriptions-item label="存证名称">{{owner}}</el-descriptions-item>-->
        <!--            <el-descriptions-item label="时间">{{createdt}}</el-descriptions-item>-->
        <!--            <el-descriptions-item label="存证">-->
        <!--                <img :src="tokenURL" alt="" height="300">-->
        <!--            </el-descriptions-item>-->
        <!--        </el-descriptions>-->
        <div class="a" v-if="tokenId">
          <!--                <div>交易哈希：</div>-->
          <div>状态：</div>
          <div>存证编号：</div>
          <div>存证名称：</div>
          <div>铸造时间：</div>
          <div>持有者：</div>
        </div>
        <div class="b" v-if="tokenId">
          <!--                <div>{{transactionId}}</div>-->
          <div>
            <span v-if="status == 0">待上链</span>
            <span v-if="status == 1">上链成功</span>
            <span v-if="status == 2">上链失败</span>
          </div>
          <div>{{ tokenId }}</div>
          <div>{{ owner.replace(/中钞/g, "融权") }}</div>
          <div>{{ createdt | dateFormate }}</div>
          <div>{{ user_id }}</div>
        </div>
        <!--        <div class="c">存证</div>-->
        <div class="d" v-if="tokenId">
          <img :src="tokenURL" alt="" height="300" />
        </div>
        <div
          v-if="!tokenId"
          style="
            margin: 0 auto;
            height: 100px;
            line-height: 100px;
            color: #606266;
            font-size: 14px;
          "
        >
          暂无数据
        </div>
      </div>
    </div>
    <div class="a2">
      <h1>转移列表</h1>
      <el-table :data="dataList" style="max-width: 1200px; margin: 0 auto">
        <el-table-column
          prop="from_user_id"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          label="发送方"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="to_user_id"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          label="接收方"
          width="180"
        >
        </el-table-column>
        <!--            <el-table-column-->
        <!--                    prop="token_name"-->
        <!--                    header-align="center"-->
        <!--                    align="center"-->
        <!--                    :show-overflow-tooltip="true"-->
        <!--                    label="存证名称"-->
        <!--                    width="180">-->
        <!--            </el-table-column>-->
        <!--                    <el-table-column-->
        <!--                            prop="channelname"-->
        <!--                            header-align="center"-->
        <!--                            align="center"-->
        <!--                            label="通道号"-->
        <!--                            width="180">-->
        <!--                    </el-table-column>-->
        <el-table-column
          prop="chain_tx_id"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          label="转移哈希"
        >
          <!--                <template slot-scope="scope">-->
          <!--                    <el-button type="text" @click="getTransaction(scope.row.chain_tx_id,scope.row.type)">{{scope.row.chain_tx_id}}</el-button>-->
          <!--                </template>-->
        </el-table-column>
        <!--            <el-table-column-->
        <!--                    prop="type"-->
        <!--                    header-align="center"-->
        <!--                    align="center"-->
        <!--                    label="类型">-->
        <!--                <template slot-scope="scope">-->
        <!--                    <span v-if="scope.row.type == '1'">铸造</span>-->
        <!--                    <span v-if="scope.row.type == '2'">交易</span>-->
        <!--                </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--                    header-align="center"-->
        <!--                    align="center"-->
        <!--                    prop="contract"-->
        <!--                    :show-overflow-tooltip="true"-->
        <!--                    label="合约名称">-->
        <!--                &lt;!&ndash;                <template slot-scope="scope">&ndash;&gt;-->
        <!--                &lt;!&ndash;                    <span>TDAPFXE7EPL4W6EMIRWV2FDLQ4XR4TZF</span>&ndash;&gt;-->
        <!--                &lt;!&ndash;                </template>&ndash;&gt;-->
        <!--            </el-table-column>-->
        <el-table-column
          prop="created_time"
          header-align="center"
          align="center"
          width="180"
          label="时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.created_time | dateFormate }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-left: 300px"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "search-details",
  data() {
    return {
      transactionId: "",
      chaincodename: "",
      createdt: "",
      tokenId: "",
      owner: "",
      tokenURL: "",
      status: "",
      total: 0,
      limit: 10,
      page: 1,
      dataList: [],
      inputValue: "",
      list: ["存证编号", "交易哈希", "用户地址", "合约地址"],
      placeholder: "",
      type: "",
    };
  },
  created() {
    this.getToken();
    this.search();
    this.getPlaceholder();
  },
  methods: {
    toHome() {
      this.$router.push({
        name: "home",
      });
    },
    getPlaceholder() {
      this.placeholder = "请输入" + this.list[0];
      this.type = this.list[0];
    },
    dropdowns(item) {
      this.placeholder = "请输入" + item;
      this.type = item;
    },
    search() {
      if (this.inputValue) {
        if (this.type == "交易哈希") {
          if (this.inputValue) {
            this.$router.push({
              path: "/hash-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "商品编号") {
          if (this.inputValue) {
            this.$router.push({
              // path: "/evidence-details",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "合约地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/contract-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        } else if (this.type == "用户地址") {
          if (this.inputValue) {
            this.$router.push({
              path: "/user-address",
              query: {
                id: this.inputValue,
              },
            });
          }
        }
      }
    },
    getToken() {
      console.log(this.$route.query.id);
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/collectioninfolist", {
          params: {
            tokenId: this.$route.query.id,
          },
        })
        .then((res) => {
          this.transactionId = res.data.data.chain_tx_id;
          this.chaincodename = res.data.data.chaincodename;
          this.createdt = res.data.data.created_time;
          this.tokenId = res.data.data.token_id;
          this.owner = res.data.data.token_name;
          this.tokenURL = res.data.data.token_uri;
          this.status = res.data.data.status;
          this.user_id = res.data.data.user_id;
          this.getutlist();
        });
    },
    getutlist() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/utlist", {
          params: {
            tokenId: this.$route.query.id,
            pageIndex: this.page,
            pageSize: this.limit,
          },
        })
        .then((res) => {
          this.dataList = res.data.data.list;
          this.total = res.data.data.count;
        });
    },
    sizeChangeHandle(val) {
      this.limit = val;
      this.page = 1;
      this.getContract();
    },
    currentChangeHandle(val) {
      this.page = val;
      this.getContract();
    },
  },
};
</script>

<style scoped lang="scss">
.token {
  .mainHead {
    height: 70px;
    background-color: #ffffff;
    width: 100%;
    /*position: fixed;*/
    /*z-index: 1;*/
    /*top: 0;*/
    .head {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      max-width: 1200px;
      .headLeft {
        cursor: pointer;
        display: flex;
        margin-top: 20px;
        img {
          width: 30px;
          height: 30px;
        }
        div {
          font-size: 16px;
          font-weight: bolder;
          margin-left: 10px;
          line-height: 30px;
          font-family: "黑体";
          /*color: #1270b9;*/
          color: rgb(44, 37, 37);
        }
      }
      .headRight {
        margin-top: 15px;
        /deep/ .el-input-group > .el-input__inner {
          background-color: #f1f1f1;
        }
        .elInput {
          width: 300px;
        }
      }
    }
  }
  .a1 {
    max-width: 1200px;
    margin: 0 auto;
    h1 {
      height: 50px;
      margin-top: 20px;
      text-align: left;
      padding-top: 20px;
      // margin-left: 360px;
      line-height: 50px;
      background-color: white;
      padding-left: 20px;
    }
    .details {
      display: flex;
      background-color: white;
      max-width: 1200px;
      /*margin-top: 50px;*/
      margin: 0 auto;
      /*position: absolute;
            left: 50%;
            transform: translate(-50%);*/
      font-size: 18px;
      .a {
        margin: 20px;
        text-align: right;
        div {
          margin-top: 20px;
          &:first-child {
            margin-top: 0;
          }
        }
      }
      .b {
        margin: 20px;
        text-align: left;
        div {
          margin-top: 20px;
          &:first-child {
            margin-top: 0;
          }
        }
      }
      .d {
        margin-left: 150px;
      }
    }
  }
  .a2 {
    max-width: 1200px;
    margin: 0 auto;
    height: 50px;
    h1 {
      height: 50px;
      margin-top: 20px;
      padding-top: 20px;
      text-align: left;
      // margin-left: 360px;
      line-height: 50px;
      background-color: white;
      padding-left: 20px;
    }
  }
}
</style>
